var video_viewer_default = {
  "video_player": "Lo9ET",
  "videoOverlay": "_6-zuc",
  "video_container": "Tq2St"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
